import React, { PureComponent, createRef } from 'react'
import PropTypes from 'prop-types'

import Button from './Button'


export default class Upload extends PureComponent {
  /* LIFECYCLE */

  /**
   * @constructor
   * @param {*} props - Properties of the PureComponent
   */
  constructor(props) {
    super(props)

    this.input = createRef()
  }


  /* METHODS */

  /**
   * Open the input
   */
  handleOpenInput = () => {
    const { current } = this.input

    if (current) {
      current.click()
    }
  }

  /**
   * When upload new file
   */
  handleFileChange = (e) => {
    e.preventDefault()

    const { name, onChange } = this.props
    const file = e.target.files[0]
    const reader = new FileReader()

    reader.onload = () => {
      const result = reader.result
        .replaceAll('\r', '')
        .replaceAll(' ', '')
        .split('\n')

      onChange({
        target: {
          name,
          value: result.map((item) => {
            const [email, phone] = item.split(',')

            return {
              phone,
              email,
            }
          }),
        },
      })
    }

    reader.readAsText(file, 'UTF-8')
  }


  /* RENDER */

  /**
   * @render
   * @returns {JSX}
   */
  render() {
    const {
      name,
      disabled,
      children,
    } = this.props

    return (
      <>
        <input
          value=""
          type="file"
          name={name}
          accept=".csv"
          ref={this.input}
          className="hidden"
          onChange={this.handleFileChange}
        />
        <Button
          color="default"
          variant="contained"
          disabled={disabled}
          onClick={this.handleOpenInput}
        >
          {children}
        </Button>
      </>
    )
  }
}


Upload.defaultProps = {
  disabled: false,
  children: 'Importer un fichier .csv',
}


Upload.propTypes = {
  value: PropTypes.any,
  name: PropTypes.string,
  children: PropTypes.node,
  accept: PropTypes.string,
  disabled: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
}
